import React, { useRef, useState } from "react";
import Cropper from "cropperjs";
import Forward5Icon from "@mui/icons-material/Forward5";
import "./cropper.css";

const ImageCropper = ({
  onCropImage,
  inputImg,
  imgName,
  closeModal,
  ratio,
}) => {
  const imageElement = useRef(null);
  const [cropper, setCropper] = useState(null);
  const [alignment, setAlignment] = useState(false);
  const showCroppedImage = () => {
    if (cropper) {
      cropper.getCropperSelection().$toCanvas().then((canvas) => {
        const maxSizeInBytes = 1024 * 1024;
        let compressionQuality = 1.0;

        // toDataURL is synchronous so we can iterate quality in a plain while loop.
        // base64 length × 0.75 ≈ actual byte size.
        let dataUrl = canvas.toDataURL("image/jpeg", compressionQuality);
        while (dataUrl.length * 0.75 > maxSizeInBytes && compressionQuality > 0.1) {
          compressionQuality = Math.round((compressionQuality - 0.1) * 10) / 10;
          dataUrl = canvas.toDataURL("image/jpeg", compressionQuality);
        }

        // toBlob requires a callback as its first argument.
        canvas.toBlob(
          (blob) => {
            const fileName = imgName || "croppedImage.jpg";
            const compressedFile = new File([blob], fileName, {
              type: "image/jpeg",
              lastModified: new Date().getTime(),
            });
            onCropImage(compressedFile);
            cropper.destroy();
            setCropper(null);
            closeModal();
          },
          "image/jpeg",
          compressionQuality
        );
      });
    } else {
      setCropper(new Cropper(imageElement.current));
    }
  };
  const rotateImage = () => {
    if (cropper) {
      cropper.getCropperImage().$rotate("5deg"); // Rotate image by 5 degrees
    } else {
      setCropper(new Cropper(imageElement.current));
    }
  };
  const rotateImageClockwise = () => {
    if (cropper) {
      cropper.getCropperImage().$rotate("-5deg"); // Rotate image by 5 degrees
    } else {
      setCropper(new Cropper(imageElement.current));
    }
  };
  return (
    <>
      <div className={`cropper ${alignment ? "right" : "left"}`}>
        <div
          className="cropper-viewport"
          style={{
            border: "1px solid #00008b",
            height: "400px",
          }}
        >
          <img
            ref={imageElement}
            src={inputImg}
            alt="Input Image"
            style={{
              // width: "400px",
              height: "400px",
            }}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center mt-2">
          <button onClick={closeModal} className="btn-cancel">
            Cancel
          </button>

          <span onClick={rotateImageClockwise} className="rotate">
            <Forward5Icon
              sx={{
                color: "#00008b",
                transform: "scaleX(-1) rotate(45deg)",
                cursor: "pointer",
              }}
            />
          </span>
          <span onClick={rotateImage} className="rotate">
            <Forward5Icon
              sx={{
                color: "#00008b",
                transform: "rotate(45deg)",
                cursor: "pointer",
              }}
            />
          </span>
          <button
            onClick={() => {
              showCroppedImage();
            }}
            className="btn-save"
          >
            {cropper ? "Save" : "Crop"}
          </button>
        </div>
      </div>
    </>
  );
};

export default ImageCropper;
